import { render, staticRenderFns } from "./VisionPlayer.vue?vue&type=template&id=1d0fffca&scoped=true&"
import script from "./VisionPlayer.vue?vue&type=script&lang=js&"
export * from "./VisionPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VisionPlayer.vue?vue&type=style&index=0&id=1d0fffca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fffca",
  null
  
)

export default component.exports